import {Injectable} from '@angular/core';
import {take} from 'rxjs/operators';
import {CustomJwtAuthService} from './custom-jwt-auth.service';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {selectUser} from '../store/selectors';
import {TenantService} from './tenant.service';
import {delay} from '../common/generic-utils';
import { Auth, idToken, signInWithCustomToken } from '@angular/fire/auth';


@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {

  authJwtToken: string;

  constructor(
    private afAuth: Auth,
    private jwtService: CustomJwtAuthService,
    private tenant: TenantService,
    private store: Store<AppState>) {

    idToken(afAuth)
      .subscribe(jwt => {
        this.authJwtToken = jwt;
        console.log(`Authentication token emitted: ${this.authJwtToken}`);
      });

    this.periodicallyRefreshToken()
      .then(() => console.log('Periodic custom token refresh started'));

  }

  private async periodicallyRefreshToken() {

    do {

      await delay(15 * 60 * 1000);

      console.log('Refreshing custom token.');

      const tenantId = this.tenant.id;

      const user = await this.store.pipe(
        select(selectUser),
        take(1)
      ).toPromise();

      const authJwtToken = await this.jwtService.createCustomJwt(tenantId, user.id).toPromise();

      const result = await signInWithCustomToken(this.afAuth, authJwtToken)

      await this.afAuth.updateCurrentUser(result.user);

    }
    while (true);

  }


}
